// Reads the latest Vercel deployment state for the admin build badge on /dev.
//
// Vercel delivers deployment webhooks to ONE backend (prod), so this is the
// single source of truth regardless of which environment the admin app runs
// in. We therefore read PROD directly + cross-origin (the endpoint sends
// wildcard CORS and returns only non-sensitive fields). Plain `fetch`, not the
// same-origin apiFetch, precisely because we want prod's data even from the
// dev/sandbox admin app.

export interface VercelDeployment {
  deployment_id: string;
  project: string | null;
  target: string | null;
  custom_environment: string | null;
  state: string; // building | ready | error | canceled | blocked | rolled_back | cleaned_up | unknown
  event: string;
  sha: string | null;
  branch: string | null;
  url: string | null;
  updated_at: string | null;
}

// Prod backend = where the webhook delivers = single source of truth.
const VERCEL_STATUS_URL =
  'https://api.tradewindsmechanical.com/api/dev/vercel-status';

export async function fetchVercelStatus(): Promise<VercelDeployment[]> {
  const res = await fetch(VERCEL_STATUS_URL, {
    headers: { Accept: 'application/json' },
  });
  if (!res.ok) {
    throw new Error(`vercel-status request failed: ${res.status}`);
  }
  const data = await res.json();
  return Array.isArray(data?.deployments) ? data.deployments : [];
}

// States that mean a deployment is still in flight — drives whether the badge
// polls (idle otherwise).
export const IN_FLIGHT_STATES = new Set(['building', 'queued']);
